import { render } from "./DetailFile.vue?vue&type=template&id=20ab3b29&scoped=true&ts=true"
import script from "./DetailFile.vue?vue&type=script&lang=ts"
export * from "./DetailFile.vue?vue&type=script&lang=ts"

import "./DetailFile.vue?vue&type=style&index=0&id=20ab3b29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ab3b29"]])

export default __exports__